import { Link } from "react-router-dom";

const LIFESTYLE =
    "https://customer-assets-lqy194kg.emergentagent.net/job_crown-oak-keyfobs/artifacts/a1yidyhb_DSC01582.webp";
const LOGO_STACKED =
    "https://customer-assets.emergentagent.com/job_0821dc2a-3ab0-4c9f-9afd-926573238371/artifacts/97lmn9lo_1.png";

const About = () => {
    return (
        <div data-testid="page-about">
            <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 pt-20 md:pt-32 pb-16 text-center">
                <p className="text-[11px] tracking-[0.35em] uppercase text-[#9E5A35] mb-6">
                    Our Story
                </p>
                <img
                    src={LOGO_STACKED}
                    alt="Crown & Oak"
                    className="mx-auto h-28 md:h-40 mb-10"
                    style={{ mixBlendMode: "multiply" }}
                />
                <h1 className="font-serif-display text-4xl md:text-6xl text-[#0A2342] leading-[1.05] max-w-3xl mx-auto">
                    Heritage, hand-stitched — one fob at a time.
                </h1>
            </section>

            <section className="max-w-2xl mx-auto px-6 md:px-8 pb-20">
                <div className="prose prose-lg max-w-none text-[#1A1A1A]/85 leading-relaxed space-y-6">
                    <p className="text-lg md:text-xl">
                        Crown &amp; Oak was born on a slow Southern afternoon —
                        the kind spent between the tenth hole and the veranda,
                        with a lime in one hand and a story to tell in the
                        other. We wanted an everyday object that carried a
                        little bit of that world in your pocket.
                    </p>
                    <p>
                        So we started with something simple: the key fob. Each
                        one is stitched by hand on cream canvas, then finished
                        with full-grain cognac leather and a polished silver
                        clasp. The designs are small tributes — a lime, a bottle
                        of whiskey, an anchor, a pineapple — quiet symbols of
                        the places we love and the people we spend time with.
                    </p>
                </div>
            </section>

            <section className="bg-white border-y border-[#E5E0D8]">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-20 md:py-28 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
                    <div className="aspect-[4/5] overflow-hidden rounded-sm">
                        <img
                            src={LIFESTYLE}
                            alt="Preppy country club lifestyle"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div>
                        <p className="text-[11px] tracking-[0.35em] uppercase text-[#9E5A35] mb-4">
                            Our Promise
                        </p>
                        <h2 className="font-serif-display text-4xl md:text-5xl text-[#0A2342] leading-[1.05]">
                            Small batch. Built to last.
                        </h2>
                        <p className="mt-6 text-base md:text-lg text-[#1A1A1A]/80 leading-relaxed">
                            We only stitch what we can do well. Every fob is
                            made in small runs, inspected by hand, and backed by
                            a 30-day satisfaction guarantee. If it doesn't feel
                            like an heirloom, we haven't done our job.
                        </p>
                        <div className="mt-10">
                            <Link
                                data-testid="about-cta-shop"
                                to="/shop"
                                className="btn-primary"
                            >
                                Shop the Collection
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
